import dateHelper from "./dateHelper";

export function SHOW_AXIOS_ERROR(error){
    if (error.response) {
        alert(error.response.status + ' ' + error.response.data);
    } else {
        alert(error.message);
    }
}

export function COMPARE_BY_START(a, b) {
    const aDate = dateHelper.toDate(a.start);
    const bDate = dateHelper.toDate(b.start);

    if (aDate > bDate) {
        return 1;
    } else if (aDate < bDate) {
        return -1;
    } else {
        return 0;
    }
}